<template>
<div>
  <h5 class="text-center"> Por favor preencha os dados iniciais do cliente. </h5>
  <div class="row">
    <div class="col-md-5 col-md-offset-1">
      <div class="form-group">
        <label class="control-label"> UC </label>
        <input
          class="form-control"
          id="uc"
          type="text"
          ref="uc"
          name="uc"
          v-validate="modelValidations.initialData.uc"
          v-model.trim="model.uc"
          v-mask="'00000000000000000000000000000000'"
          autofocus
          autocomplete="off"
        />
        <small
          class="text-danger"
          v-show="uc.invalid"
        > {{ getError('uc') }}
        </small>
      </div>
    </div>
    <div class="col-md-5">
      <div class="form-group">
        <label class="control-label"> CPF </label>
        <input
          class="form-control"
          type="text"
          name="cpf"
          v-validate="modelValidations.initialData.cpf"
          v-model.trim="model.cpf"
          v-mask-cpf
          autocomplete="off"
        />
        <small
          class="text-danger"
          v-show="cpf.invalid"
        > {{ getError('cpf') }}
        </small>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapFields } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { cpfIsValidRule } from 'src/services/ValidationRules'

export default {
  name: 'initial-data-form',

  data () {
    return {}
  },

  computed: {
    ...mapFields(['uc', 'cpf']),
    ...mapGetters(['config']),
    ...mapGetters('customers', {
      model: 'customer',
      modelValidations: 'validations',
      loading: 'loading'
    })
  },

  methods: {
    ...mapActions('customers', [
      'fetchOne',
      'resetOne',
      'insert',
      'update'
    ]),

    getError (fieldName) {
      return this.errors.first(fieldName)
    },

    validate () {
      return this.$validator.validateAll()
    }
  },

  created () {
    this.$validator.extend('cpf', cpfIsValidRule)
  },

  mounted () {
    if (this.editing) {
      this.fetchOne(this.id)
    } else {
      this.resetOne()
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Customers/Forms/InitialDataForm.vue